import { NavTab } from "../NavTab/NavTab";
import "./Navigations.css";

const Navigations = () => {
  return (
    <div className="navigationmain">
      <NavTab />
    </div>
  );
};

export default Navigations;
